import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { safePagePath, safePageLocation } from '../lib/analytics';

const GA_ID = 'G-EGW0FRW1KE';
// Sign-in, sign-up, password reset and invite pages: no GA and no referrer at all.
export const SENSITIVE_PATHS = ['/login', '/register', '/test-drive', '/forgot-password', '/reset-password',
  '/verify-invite', '/admin/login', '/mobile/login'];
export const isSensitivePath = (p) => SENSITIVE_PATHS.some((s) => p === s || p.startsWith(`${s}/`));

const setReferrerPolicy = (policy) => {
  const meta = document.getElementById('referrer-policy');
  if (meta) meta.setAttribute('content', policy);
};

let gaLoaded = false;
const loadGa = () => {
  if (gaLoaded || window.self !== window.top) return; // never inside the Emergent edit iframe
  gaLoaded = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, { send_page_view: false, page_location: `${window.location.origin}/`, page_referrer: window.location.origin });
};

/**
 * AnalyticsTracker: the single source of GA4 page_view events. gtag.js is loaded only once the user
 * reaches a non-sensitive page; only a cleaned path is sent (no query string, IDs replaced with :id),
 * also set as the default page_location/referrer so no event carries tokens or record IDs.
 */
export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    if (isSensitivePath(location.pathname)) { setReferrerPolicy('no-referrer'); return; }
    setReferrerPolicy('strict-origin-when-cross-origin');
    loadGa();
    const page_location = safePageLocation(location.pathname);
    window.gtag('set', { page_location, page_referrer: window.location.origin });
    window.gtag('event', 'page_view', {
      page_path: safePagePath(location.pathname),
      page_location,
      page_title: 'EQUIPR Guardian',
    });
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
